import React from "react";
import { BellRing, Inbox, MousePointerClick, Shuffle } from "lucide-react";
import "./RoutingExplainer.scss";

export const ROUTING_EXAMPLES = {
  rotate: "Lead 1 goes to Jennifer, lead 2 to Pat, lead 3 to Maria, then back to Jennifer.",
  area: "A buyer looking in 79424 goes to the agent you set for 79424.",
  price: "A buyer with a $450K budget goes to the agent you set for $400K to $600K.",
  visitor: "The visitor picks Pat on the card, so the lead goes to Pat.",
};

export const ruleLabelOf = (mode) =>
  ({
    rotate: "Takes turns across your agents",
    area: "Matches the buyer's ZIP code",
    price: "Matches the buyer's budget",
    visitor: "Uses the agent the visitor picked",
  })[mode] || "Takes turns across your agents";

const Step = ({ index, icon: Icon, title, body, rule = false }) => (
  <li className={`routing-explainer__step${rule ? " is-rule" : ""}`} style={{ "--i": index }}>
    <span className="routing-explainer__node" aria-hidden="true">
      <Icon size={18} strokeWidth={1.75} />
    </span>
    <span className="routing-explainer__text">
      <strong>{title}</strong>
      <span>{body}</span>
    </span>
  </li>
);

const RoutingExplainer = ({ mode = "rotate", crm = false }) => (
  <figure className="routing-explainer" aria-label="How a lead from your website reaches an agent">
    <ol className="routing-explainer__flow">
      <Step index={0} icon={MousePointerClick} title="A visitor taps Contact" body={"On a Buyer Want\u2011Listing card on your website."} />
      <Step index={1} icon={Shuffle} rule title={ruleLabelOf(mode)} body="Gitcha picks the agent with the rule you choose below." />
      <Step index={2} icon={BellRing} title="The agent hears right away" body="An email every time, and a text when their phone is on file." />
      <Step
        index={3}
        icon={Inbox}
        title="The lead is saved"
        body={crm ? "In their Analytics leads, My Clients and your CRM." : "In their Analytics leads and My Clients."}
      />
    </ol>
    <figcaption className="routing-explainer__example">{ROUTING_EXAMPLES[mode] || ROUTING_EXAMPLES.rotate}</figcaption>
  </figure>
);

export default RoutingExplainer;
